import { LuneThemeNew, Text } from '@lune-fe/lune-ui-lib'
import { SxProps } from '@mui/material'
import Box from '@mui/material/Box'
import { FC } from 'react'

import {
    dataSheetTypeConversion,
    DataSheetTypeOrUnknown,
} from 'views/CalculateEmissions/Shared/utils'

const { palette } = LuneThemeNew

interface ImportTypeChipProps {
    type: DataSheetTypeOrUnknown
    filename: string | null
    sx?: SxProps
}

export const getTypeColor = (type: DataSheetTypeOrUnknown): string => {
    const colorMap: Record<DataSheetTypeOrUnknown, string> = {
        lune: palette.Data100,
        ecotransit: palette.Data700,
        lune_logistics_v2: palette.Data300,
        lune_fintech: palette.Data600,
        rfq: palette.Data600,
        logistics_user_template: palette.Data400,
        estimate_sheet_v1: palette.Data300,
        shipment_sheet_v1: palette.Data400,
        unknown: palette.Surface700,
    }

    return colorMap[type]
}

const getTypeLabel = (type: DataSheetTypeOrUnknown, filename: string | null): string => {
    if (filename) {
        return middleEllipsize(filename, 20)
    }

    return dataSheetTypeConversion[type]
}

export const middleEllipsize = (text: string, maxChars = 24): string => {
    if (text.length <= maxChars || maxChars < 5) {
        return text
    }
    const keep = maxChars - 1
    const left = Math.ceil(keep / 2)
    const right = Math.floor(keep / 2)
    return `${text.slice(0, left)}…${text.slice(text.length - right)}`
}

export const ImportTypeChip: FC<ImportTypeChipProps> = ({ type, filename, sx }) => {
    const color = getTypeColor(type)
    const label = getTypeLabel(type, filename)

    return (
        <Box
            title={filename || label}
            sx={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '8px',
                px: 1,
                py: 1 / 2,
                borderRadius: '100px',
                backgroundColor: color + '30', // 30% opacity
                lineHeight: 1,
                whiteSpace: 'nowrap',
                ...sx,
            }}
        >
            <Text
                variant={'body3'}
                sx={{
                    textOverflow: 'ellipsis',
                    overflow: 'hidden',
                }}
            >
                {label}
            </Text>
        </Box>
    )
}

export default ImportTypeChip
